<template>
  <transition name='fade'>
  <v-app>
      <BranchTracker/>
      <AppBar v-if="$route.name!=='Campaign'"/>

      <v-content :class="['pa-0',{['mt80']:$route.name!=='Campaign'}]">

        <ViewController/>
        <SecurityController/>
        <ProgramController v-if="$store.getters.csrf"/>
        <transition
          enter-active-class="animated fadeIn"
          appear-active-class="animated fadeOut"        
          >
          <router-view/>  
        </transition>      
      </v-content>

      <!-- OVERLAYS -->

      <!-- Program Admin -->
      <ProgramAdminQuickAccess />


      <!-- LOGIN / REGISTER -->
      <LoginRegister v-on:close="$controller.view.login.close();"/>

      <!-- Contact Us -->
      <ContactUs v-on:close="$controller.view.contactUs.close();" />

      <!-- Edit Profile -->
      <EditProfile v-on:close="$controller.view.editProfile.close();" />
      
      <!-- Site Regulation -->
      <SiteRegulationContainer v-on:close="$controller.view.SiteRegulation.close();" />
      
      <!-- WelcomeBackWizard :: handldes v2 users auto migrated to v4 on first login -->
      <WelcomeBackWizard v-on:close="$controller.view.editProfile.open();" />
      
      <!-- PWC RECAPTURE -->
      <PWC_RECAP v-if="$controller.program && $controller.program.myPrograms()" :show="popups.PWC_RECAP" @open="popups.PWC_RECAP=true" @close="popups.PWC_RECAP=false" :myprograms="$controller.program.myPrograms()"/>

      <!-- BUSY SPINNER -->
      <v-dialog v-model="isBusy" persistent>
        <v-overlay>
          <v-progress-circular indeterminate size="64"></v-progress-circular>          
        </v-overlay>
      </v-dialog>

      <!-- Progres Bar -->
      <v-dialog :value="$store.getters.progressBar!=null" persistent>
        <v-progress-linear
          color="light-blue"
          height="10"
          :value="$store.getters.progressBar"
          striped
        ></v-progress-linear>        
      </v-dialog>

      <!-- Footer -->
      <Footer />

      <v-fab-transition>
        <v-btn
          id="backTop"
          style="display: none; bottom: 5%; right: 2%; z-index: 999"
          dark
          fab
          small
          color="#0090c1"
          @click="goBackTop"
        >
          <v-icon>fas fa-caret-up</v-icon>
        </v-btn>
      </v-fab-transition>

  </v-app>
  </transition>
</template>

<script>
import BranchTracker from '@/components/BranchTracker/BranchTracker.vue';
import AppBar from '@/components/UI/AppBar.vue';
import LoginRegister from '@/components/Login_Register/View.vue';
import ContactUs from '@/components/ContactUs/ContactUs.vue';
import EditProfile from '@/components/EditProfile/EditProfile.vue';
import ViewController from '@/Controllers/View/View.vue';
import ProgramController from '@/Controllers/Program/ProgramControl.vue';
import SecurityController from '@/Controllers/Security/Security.vue';
import Footer from '@/components/UI/Footer.vue'
import SiteRegulationContainer from '@/components/SiteRegulation/SiteRegulationContainer.vue';
import WelcomeBackWizard from '@/components/WelcomeBackWizard/WelcomeBackWizard.vue';
import ProgramAdminQuickAccess from '@/components/Admin/ProgramAdmin/ProgramAdminQuickAccess.vue';
import PWC_RECAP from '@/components/CustomProject/Recap/Recap.vue';
import GoogleTagMngHandler from '@/Controllers/helper/GoogleTagMngHandler.js'

export default {
  name: 'App',
  components: {
    BranchTracker,
    AppBar,
    LoginRegister,
    ContactUs,
    EditProfile,
    ViewController,
    ProgramController,
    SecurityController,
    Footer,
    SiteRegulationContainer,
    WelcomeBackWizard,
    ProgramAdminQuickAccess,
    PWC_RECAP
  },
  data: () => ({
        busy: false,
        popups: {
          PWC_RECAP: false
        }
  }),
  created: function() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function(){
    this.$controller.gtmHandler = GoogleTagMngHandler;    
  },
  methods: {
    goBackTop: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    handleScroll: function() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById("backTop").style.display = "flex";
        document.getElementById("backTop").style.position = "fixed";
      } else {
        document.getElementById("backTop").style.display = "none";
      }
    }
  },
  computed: {
    isBusy: function(){
      return this.$store.getters.busy>0;
    }
  },
  watch: {
        mode: function(){
          this.$store.dispatch('mode',this.mode);
        }
  }
};
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.mt80 {
    margin-top:80px;
}
</style>
<style src="./assets/css/material_fonts.css"></style>
<style src="./assets/css/material_icons.css"></style>
<style src="./assets/css/all.css"></style>
<style src="./assets/css/vuetify.min.css"></style>
<style src="./assets/css/animate.css"></style>
<!--<style src="./assets/css/swiper.min.css"></style>-->